import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Button, Form } from 'react-bootstrap';
import { toastMessageBox } from 'components/ToastifyMessage';
const API = process.env.REACT_APP_API_PATH;

const ForgetPasswordForm = () => {
  // State
  const [userName, setUserName] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState(''); // Add error message state

  // Handler
  const handleSubmit = async e => {
    e.preventDefault();
    setErrorMsg(''); // Clear previous error
    if (userName) {
      setLoading(true);
      try {
        console.log(userName)
        // Replace the URL below with your actual backend endpoint
        const res = await fetch(`${API}/auth/forgot-password`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ userName })
        });
        if (res.ok) {
          toastMessageBox("Email Confirmation",`An email is sent to ${userName} with password reset link`,"success");
        } else if (res.status === 404) {
          setErrorMsg("Your account is locked. Please contact the support team for assistance.");
        } else {
          toastMessageBox("Error","Failed to send reset email. Please try again.","error");
        }
      } catch (err) {
        toastMessageBox("Error","Network error. Please try again.","error");
      }
      setLoading(false);
    }
  };

  return (
    <Form className="mt-4" onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        <Form.Control
          placeholder={"Enter the Email"}
          value={userName}
          name="userName"
          onChange={({ target }) => setUserName(target.value)}

        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Button className="w-100" type="submit" disabled={!userName || loading}>
          {loading ? 'Sending...' : 'Send reset link'}
        </Button>
      </Form.Group>

      {errorMsg && (
        <div style={{ color: 'red', marginBottom: '1rem' }}>{errorMsg}</div>
      )}

      
    </Form>
  );
};

ForgetPasswordForm.propTypes = {
  layout: PropTypes.string
};

ForgetPasswordForm.defaultProps = { layout: 'simple' };

export default ForgetPasswordForm;
